import type { CashVarianceCaseStatus } from './cash-variance.dto.js';
import type {
  CashReportActorRefDto,
  CashReportCashLocationRefDto,
  CashReportSessionRefDto,
} from './cash-report-common.dto.js';

export const cashVarianceAgingBucketValues = ['0-7', '8-14', '15-30', '31+'] as const;
export type CashVarianceAgingBucket = (typeof cashVarianceAgingBucketValues)[number];

export interface GetCashVarianceMonthlySummaryReportRequest {
  companyId: string;
  fromMonth: string;
  toMonth: string;
  storeId?: string;
  locationId?: string;
  stationId?: string;
  cashLocationId?: string;
  actorUserId?: string;
}

export interface CashVarianceMonthlySummaryReportItemDto {
  month: string;
  shortageCreatedAmountMinor: number;
  overageCreatedAmountMinor: number;
  recoveredAmountMinor: number;
  writtenOffAmountMinor: number;
  offsetAmountMinor: number;
  classifiedAmountMinor: number;
  removedAmountMinor: number;
  unresolvedAmountMinor: number;
  shortageCaseCount: number;
  overageCaseCount: number;
  recoveryActionCount: number;
  writeoffActionCount: number;
  offsetActionCount: number;
  classificationActionCount: number;
  removalActionCount: number;
  unresolvedCaseCount: number;
  forceUnverifiedAuditRiskCount: number;
}

export interface GetCashVarianceMonthlySummaryReportResponse {
  items: CashVarianceMonthlySummaryReportItemDto[];
}

export interface GetCashUnresolvedVarianceAgingReportRequest {
  companyId: string;
  storeId?: string;
  locationId?: string;
  stationId?: string;
  cashLocationId?: string;
  status?: CashVarianceCaseStatus;
  actorUserId?: string;
  from?: string;
  to?: string;
  asOf?: string;
}

export interface CashUnresolvedVarianceAgingBucketDto {
  bucket: CashVarianceAgingBucket;
  unresolvedAmountMinor: number;
  caseCount: number;
}

export interface CashUnresolvedVarianceAgingAuditRiskBucketDto {
  bucket: CashVarianceAgingBucket;
  auditRiskCount: number;
}

export interface CashUnresolvedVarianceAgingMonetaryRowDto {
  bucket: CashVarianceAgingBucket;
  caseId: string;
  status: CashVarianceCaseStatus;
  openedAt: string;
  ageDays: number;
  initialAmountMinor: number;
  unresolvedAmountMinor: number;
  cashLocation: CashReportCashLocationRefDto;
  session: CashReportSessionRefDto | null;
  openedBy: CashReportActorRefDto | null;
}

export interface CashUnresolvedVarianceAgingAuditRiskRowDto {
  bucket: CashVarianceAgingBucket;
  cashSessionId: string;
  closedAt: string;
  ageDays: number;
  expectedCashMinor: number;
  countedCashMinor: null;
  varianceAmountMinor: null;
  auditRisk: true;
  cashLocation: CashReportCashLocationRefDto;
  session: CashReportSessionRefDto;
  closedBy: CashReportActorRefDto | null;
}

export interface GetCashUnresolvedVarianceAgingReportResponse {
  asOf: string;
  monetaryBuckets: CashUnresolvedVarianceAgingBucketDto[];
  monetaryRows: CashUnresolvedVarianceAgingMonetaryRowDto[];
  auditRiskBuckets: CashUnresolvedVarianceAgingAuditRiskBucketDto[];
  auditRiskRows: CashUnresolvedVarianceAgingAuditRiskRowDto[];
  unresolvedAmountMinor: number;
  unresolvedCaseCount: number;
  forceUnverifiedAuditRiskCount: number;
}
